export enum BeforeAfter {
  BEFORE = 'Before',
  AFTER = 'After'
}
